import { Constants } from '@local/common';
import { SideBarOptions } from './settings-sidebar.component';
import { Config } from '@environments/config';

export const sideBarOptionsData: SideBarOptions[] = [
  {
    sections: [
      {
        title: 'My Profile',
        icon: {
          type: 'font',
          value: 'icon-user1',
        },
        path: 'my-profile',
        telemetry: 'my-profile',
      },
      {
        title: 'Workspace',
        icon: {
          type: 'font',
          value: 'icon-settings-company',
        },
        path: 'workspace',
        telemetry: 'workspace.general',
        requiredPermission: 'OwnerOrAdmin',
      },
      {
        title: 'Unleash AI',
        icon: {
          type: 'font',
          value: 'icon-answer',
        },
        path: 'unleash-ai',
        telemetry: 'unleash-ai',
        requiredPermission: 'OwnerOrAdmin',
      },
      {
        title: 'Assistants',
        icon: {
          type: 'font',
          value: 'icon-assistant',
        },
        path: 'assistants',
        telemetry: 'assistants',
      },
      {
        title: 'Notifications',
        icon: {
          type: 'font',
          value: 'icon-windows-ringer',
        },
        path: 'notifications',
        telemetry: 'notifications',
        requiredPermission: 'OwnerOrAdmin',
      },
      {
        title: 'API Keys',
        icon: {
          type: 'font',
          value: 'icon-file-key',
        },
        path: 'api-keys',
        telemetry: 'api-keys',
        disableFlag: Constants.ENABLED_API_KEYS,
      },
      {
        title: 'Users',
        icon: {
          type: 'font',
          value: 'icon-members',
        },
        path: 'users',
        telemetry: 'security.users',
        requiredPermission: 'MemberOnly',
      },
      {
        title: 'Analytics',
        icon: {
          type: 'font',
          value: 'icon-analytics',
        },
        path: 'analytics',
        telemetry: 'analytics',
        requiredPermission: 'Member',
      },
    ],
  },
  {
    title: 'SEARCH',
    sections: [
      {
        title: 'Sources',
        icon: {
          type: 'font',
          value: 'icon-source',
        },
        path: 'sources',
        telemetry: 'data-lake.sources',
        countProperty: 'links',
      },
      {
        title: 'Settings',
        icon: {
          type: 'font',
          value: 'icon-setting-preferences',
        },
        path: 'search',
        telemetry: 'settings',
      },
    ],
  },
  {
    title: 'SECURITY',
    sections: [
      {
        title: 'Users',
        icon: {
          type: 'font',
          value: 'icon-members',
        },
        path: 'users',
        telemetry: 'security.users',
        requiredPermission: 'OwnerOrAdmin',
      },
      {
        title: 'Sign In',
        icon: {
          type: 'font',
          value: 'icon-signin',
        },
        path: 'sign-in',
        telemetry: 'security.sign-in',
        requiredPermission: 'OwnerOrAdmin',
      },
      {
        title: 'Permissions',
        icon: {
          type: 'font',
          value: 'icon-user-permission',
        },
        path: 'permissions',
        telemetry: 'security.permissions',
        requiredPermission: 'OwnerOrAdmin',
      },
    ],
  },
  {
    title: 'ADD ONS',
    sections: [
      {
        title: 'Experiences',
        icon: {
          type: 'font',
          value: 'icon-cube',
        },
        path: 'experiences',
        telemetry: 'addons.experiences',
      },
      {
        title: 'Browser Extension',
        icon: {
          type: 'font',
          value: 'icon-extension',
        },
        path: 'extension',
        telemetry: 'addons.extension',
      },
    ],
  },
];
